import React from 'react'
import Header from '../components/Header'
import { Link } from 'react-router-dom'
import CourseAccordion from '../components/accordion'

const Videos = () => {
  return (
    <div>
      
      <Header/>
          <div className="big-card big-carded">
          <div className="side1 side11">
             <h1>AyTida kasb tanlash:  <br /> amaliy 30 kun</h1>
            <p className='ptag' >AyTidagi yo‘nalishlarni tartibli ko‘rib chiqing. Turli kasblar bilan <br /> tanishib, o‘zingizga mos yo‘lni tanlang.</p>
   
    <Link to={"/enroll"}><button>xarid qilish</button></Link>
    <Link to={"/enroll"}><button>Videolar bilan tanishish</button></Link>
          </div>

          <div className="side2 sided">
<img src="/ui.jpg" alt="ui logo" />
          </div>
        </div>
        <CourseAccordion/>
    </div>
    
  )
}

export default Videos